module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chat-page"
  }, [_c('div', {
    staticClass: "chat-hero"
  }, [_c('div', {
    staticClass: "chat-hero__title"
  }, [_vm._m(0), _vm._v(" "), _c('div', [_c('h1', [_vm._v(_vm._s(_vm.locale.t('label_user_chat')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.locale.t('label_conversations')))])])]), _vm._v(" "), (_vm.canStartConversation()) ? _c('div', {
    staticClass: "chat-actions"
  }, [_c('button', {
    staticClass: "chat-action-button chat-action-button--secondary",
    on: {
      "click": _vm.openFaq
    }
  }, [_c('i', {
    staticClass: "ti-help-alt"
  }), _vm._v(" " + _vm._s(_vm.locale.t('label_faq')) + "\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "chat-action-button",
    on: {
      "click": function($event) {
        return _vm.startConversation('ADMIN')
      }
    }
  }, [_c('i', {
    staticClass: "ti-comments"
  }), _vm._v(" " + _vm._s(_vm.locale.t('label_new_message_admin')) + "\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "chat-action-button chat-action-button--secondary",
    on: {
      "click": function($event) {
        return _vm.startConversation('TRAINER')
      }
    }
  }, [_c('i', {
    staticClass: "ti-comment-alt"
  }), _vm._v(" " + _vm._s(_vm.locale.t('label_new_message_trainer')) + "\n      ")])]) : (_vm.isStaffChat()) ? _c('div', {
    staticClass: "chat-actions"
  }, [_c('button', {
    staticClass: "chat-action-button chat-action-button--secondary",
    on: {
      "click": _vm.openFaq
    }
  }, [_c('i', {
    staticClass: "ti-help-alt"
  }), _vm._v(" " + _vm._s(_vm.locale.t('label_faq')) + "\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "chat-action-button",
    on: {
      "click": _vm.chooseUserDialog
    }
  }, [_c('i', {
    staticClass: "ti-user"
  }), _vm._v(" " + _vm._s(_vm.locale.t('label_start_chat')) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "chat-hero__count"
  }, [_vm._v(_vm._s(_vm.filteredConversations.length))])]) : _vm._e()]), _vm._v(" "), (_vm.isStaffChat() && _vm.selectedUser != null) ? _c('div', {
    staticClass: "chat-selected-user"
  }, [_c('div', {
    staticClass: "chat-selected-user__info"
  }, [(_vm.selectedUser.profilePicture != null && _vm.selectedUser.profilePicture.length > 0) ? _c('img', {
    staticClass: "chat-avatar",
    attrs: {
      "src": _vm.selectedUser.profilePicture
    }
  }) : _c('img', {
    staticClass: "chat-avatar",
    attrs: {
      "src": require("../../assets/img/icons/missing_image.svg")
    }
  }), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "chat-conversation-title"
  }, [_vm._v(_vm._s(_vm.selectedUser.name) + " " + _vm._s(_vm.selectedUser.surname))]), _vm._v(" "), _c('div', {
    staticClass: "chat-conversation-meta"
  }, [_vm._v(_vm._s(_vm.selectedUser.username))])])]), _vm._v(" "), _c('button', {
    staticClass: "chat-action-button",
    on: {
      "click": _vm.startConversationWithSelectedUser
    }
  }, [_c('i', {
    staticClass: "ti-comment-alt"
  }), _vm._v(" " + _vm._s(_vm.locale.t('label_start_conversation')) + "\n    ")])]) : _vm._e(), _vm._v(" "), (_vm.isStaffChat()) ? _c('div', {
    staticClass: "chat-search"
  }, [_c('i', {
    staticClass: "ti-search"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }],
    staticClass: "chat-search__input",
    attrs: {
      "type": "text",
      "placeholder": _vm.locale.t('label_search_users')
    },
    domProps: {
      "value": (_vm.searchQuery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.isStaffChat()) ? _c('div', {
    staticClass: "chat-tabs"
  }, [_c('button', {
    staticClass: "chat-tab",
    class: {
      'chat-tab--active': _vm.activeStatus === 'ACTIVE'
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus('ACTIVE')
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.locale.t('label_chat_active')) + "\n    ")]), _vm._v(" "), _c('button', {
    staticClass: "chat-tab",
    class: {
      'chat-tab--active': _vm.activeStatus === 'CLOSED'
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus('CLOSED')
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.locale.t('label_chat_closed')) + "\n    ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "chat-panel"
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "chat-empty"
  }, [_vm._v(_vm._s(_vm.locale.t('label_loading')))]) : (_vm.errorMessage) ? _c('div', {
    staticClass: "form-error"
  }, [_vm._v(_vm._s(_vm.errorMessage))]) : (_vm.conversations.length === 0) ? _c('div', {
    staticClass: "chat-empty"
  }, [_vm._v(_vm._s(_vm.locale.t('label_no_conversations')))]) : (_vm.filteredConversations.length === 0) ? _c('div', {
    staticClass: "chat-empty"
  }, [_vm._v(_vm._s(_vm.locale.t('label_no_data')))]) : _vm._e(), _vm._v(" "), _vm._l((_vm.filteredConversations), function(conversation) {
    return _c('div', {
      key: conversation.id,
      staticClass: "chat-conversation-row",
      on: {
        "click": function($event) {
          return _vm.openConversation(conversation)
        }
      }
    }, [(_vm.isStaffChat() && conversation.profilePicture != null && conversation.profilePicture.length > 0) ? _c('img', {
      staticClass: "chat-avatar",
      attrs: {
        "src": conversation.profilePicture
      }
    }) : (_vm.isStaffChat()) ? _c('img', {
      staticClass: "chat-avatar",
      attrs: {
        "src": require("../../assets/img/icons/missing_image.svg")
      }
    }) : _c('div', {
      staticClass: "chat-avatar chat-avatar--initials"
    }, [_vm._v(_vm._s(_vm.getTargetInitial(conversation)))]), _vm._v(" "), _c('div', {
      staticClass: "chat-conversation-main"
    }, [_c('div', {
      staticClass: "chat-conversation-title"
    }, [_c('span', [_vm._v(_vm._s(_vm.isStaffChat() ? _vm.getConversationName(conversation) : _vm.getTargetLabel(conversation)))])]), _vm._v(" "), _c('div', {
      staticClass: "chat-conversation-meta"
    }, [(conversation.trainerName) ? _c('span', [_vm._v(_vm._s(conversation.trainerName))]) : _vm._e(), _vm._v(" "), (conversation.lastMessageAt) ? _c('span', [_vm._v(" · " + _vm._s(_vm.formatDate(conversation.lastMessageAt)))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "chat-conversation-last"
    }, [_vm._v(_vm._s(conversation.lastMessageText || _vm.locale.t('label_no_messages')))])]), _vm._v(" "), (conversation.unreadCount > 0) ? _c('span', {
      staticClass: "chat-badge"
    }, [_vm._v(_vm._s(conversation.unreadCount))]) : _vm._e(), _vm._v(" "), (_vm.isStaffChat() && conversation.status !== 'CLOSED') ? _c('button', {
      staticClass: "chat-close-button",
      attrs: {
        "title": _vm.locale.t('label_close_conversation')
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.closeConversation(conversation)
        }
      }
    }, [_c('i', {
      staticClass: "ti-close"
    })]) : _vm._e(), _vm._v(" "), _c('i', {
      staticClass: "ti-angle-right chat-row-arrow"
    })])
  })], 2), _vm._v(" "), _c('choose-user-modal', {
    attrs: {
      "show": _vm.chooseUser,
      "skip-trainer-select": true
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chat-hero__icon"
  }, [_c('i', {
    staticClass: "ti-comments"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-90f9f5a2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chat/UserChat.vue
// module id = 829
// module chunks = 0